import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'

const PoiTabsAndCounters = ({ dataStore, t }) => {
  const poi = dataStore && dataStore.poi
  const allMarkers = (poi && poi.getMarkersForBucketDisplay)
    ? poi.getMarkersForBucketDisplay()
    : ((poi && poi.temporaryMarkers) || [])

  return (
    <div>
      <div className='search-results__tabs-wrap'>
        <div className='search-results__section-title'>{t('POI.VIEW_SECTION_TITLE')}</div>
        <div className='search-results__tabs'>
          {['all', 'general', 'competitor', 'ally'].map(tab => (
            <button
              key={tab}
              className={`search-results__tab-button ${poi && poi.viewFilter === tab ? 'search-results__tab-button--active' : ''}`}
              onClick={() => poi && poi.setViewFilter(tab)}
            >
              {tab === 'all' && t('POI.VIEW_TAB_ALL')}
              {tab === 'general' && t('POI.BUCKET_GENERAL')}
              {tab === 'competitor' && t('POI.BUCKET_COMPETITORS')}
              {tab === 'ally' && t('POI.BUCKET_ALLIES')}
            </button>
          ))}
        </div>
      </div>

      {allMarkers.length > 0 && (
        <div className='search-results__type-counters-wrap'>
          <div className='search-results__type-row' key='points_of_interest'>
            {(() => {
              const globalCounts = allMarkers.reduce((acc, m) => {
                const currentBuckets = (poi && poi.bucketById && poi.bucketById.get && poi.bucketById.get(m.id))
                const baselineBuckets = (poi && poi.sharedBucketsById && poi.sharedBucketsById.get && poi.sharedBucketsById.get(m.id))
                const removedBuckets = (poi && poi.removedFromBucketById && poi.removedFromBucketById.get && poi.removedFromBucketById.get(m.id)) || []
                const hasCurrent = poi && poi.bucketById && poi.bucketById.has && poi.bucketById.has(m.id)
                let buckets = hasCurrent ? (currentBuckets || []) : (baselineBuckets || [])

                if (!hasCurrent && removedBuckets.length > 0) {
                  buckets = buckets.filter(b => !removedBuckets.includes(b))
                }

                if (buckets.includes('general')) acc.general++
                if (buckets.includes('ally')) acc.allies++
                if (buckets.includes('competitor')) acc.competitors++
                return acc
              }, { general: 0, allies: 0, competitors: 0 })

              const tab = (poi && poi.viewFilter) || 'all'

              return (
                <div className='search-results__type-counter'>
                  {(tab === 'all' || tab === 'general') && globalCounts.general > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--general'
                      style={{ width: `${8 * globalCounts.general}%` }}
                    >
                      {globalCounts.general}
                    </span>
                  )}
                  {(tab === 'all' || tab === 'ally') && globalCounts.allies > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--ally'
                      style={{ width: `${8 * globalCounts.allies}%` }}
                    >
                      {globalCounts.allies}
                    </span>
                  )}
                  {(tab === 'all' || tab === 'competitor') && globalCounts.competitors > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--competitor'
                      style={{ width: `${8 * globalCounts.competitors}%` }}
                    >
                      {globalCounts.competitors}
                    </span>
                  )}
                </div>
              )
            })()}
            <span className='search-results__type-title'>{t('POI.COUNTER_POINTS_OF_INTEREST')}</span>
          </div>

          {Object.entries(
            allMarkers.reduce((acc, m) => {
              // Get current bucket state (user's changes)
              const currentBuckets = (poi && poi.bucketById && poi.bucketById.get && poi.bucketById.get(m.id))
              // Get baseline bucket state (persisted)
              const baselineBuckets = (poi && poi.sharedBucketsById && poi.sharedBucketsById.get && poi.sharedBucketsById.get(m.id))
              // Get removed buckets (user removed from baseline)
              const removedBuckets = (poi && poi.removedFromBucketById && poi.removedFromBucketById.get && poi.removedFromBucketById.get(m.id)) || []

              // Use current state if it exists, otherwise use baseline
              const hasCurrent = poi && poi.bucketById && poi.bucketById.has && poi.bucketById.has(m.id)
              let buckets = hasCurrent ? (currentBuckets || []) : (baselineBuckets || [])

              // Filter out removed buckets from baseline
              if (!hasCurrent && removedBuckets.length > 0) {
                buckets = buckets.filter(b => !removedBuckets.includes(b))
              }

              if (buckets.length === 0) return acc
              const type = m.type || t('POI.TYPE_OTHER')
              if (!acc[type]) acc[type] = { general: 0, allies: 0, competitors: 0 }
              if (buckets.includes('general')) acc[type].general++
              if (buckets.includes('ally')) acc[type].allies++
              if (buckets.includes('competitor')) acc[type].competitors++
              return acc
            }, {})
          ).map(([type, counts]) => {
            const tab = (poi && poi.viewFilter) || 'all'

            const showGeneral = tab === 'all' || tab === 'general'
            const showAllies = tab === 'all' || tab === 'ally'
            const showCompetitors = tab === 'all' || tab === 'competitor'

            const hasAny =
              (showGeneral && counts.general > 0) ||
              (showAllies && counts.allies > 0) ||
              (showCompetitors && counts.competitors > 0)

            if (!hasAny) return null

            return (
              <div className='search-results__type-row' key={type}>
                <div className='search-results__type-counter'>
                  {showGeneral && counts.general > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--general'
                      style={{ width: `${8 * counts.general}%` }}
                    >
                      {counts.general}
                    </span>
                  )}
                  {showAllies && counts.allies > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--ally'
                      style={{ width: `${8 * counts.allies}%` }}
                    >
                      {counts.allies}
                    </span>
                  )}
                  {showCompetitors && counts.competitors > 0 && (
                    <span
                      className='search-results__type-group search-results__type-group--competitor'
                      style={{ width: `${8 * counts.competitors}%` }}
                    >
                      {counts.competitors}
                    </span>
                  )}
                </div>
                <span className='search-results__type-title'>{type}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default withTranslation()(
  inject('dataStore')(observer(PoiTabsAndCounters))
)
